/**
 * Story card directive
 * @author Ryan Gladstone
 * Webpack migration by Umer Hassan
 */

import taskSlimTemplate from './taskSlim.html';

function TaskSlimController($scope, layoutService, featureFlag) {
  $scope.layout = layoutService;

  $scope.tasksv2enabled = false;

  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });
}

function directive() {
  return {
    restrict: 'AE',
    scope: {
      task: '=',
      singleView: '='
    },
    template: taskSlimTemplate,
    controller: [
      '$scope',
      'layoutService',
      'featureFlag',
      TaskSlimController
    ]
  };
}

export default function (ngModule) {
  ngModule.directive('taskSlim', directive);
}
